var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getGtagItemFromProductTile, sendViewItemListEvent, sendSelectItemEvent, } from "./analytics/google-analytics";
import { FruugoAnalyticsClickEvent } from "./analytics/fruugo-analytics/FruugoAnalyticsClickEvent";
import { FruugoAnalyticsImpressionEvent } from "./analytics/fruugo-analytics/FruugoAnalyticsImpressionEvent";
export function sendImpressionsForProductTiles(tiles) {
    var _a;
    if (tiles.length === 0)
        return;
    var parent = tiles[0].parentNode;
    if (!parent)
        return;
    var siblings = Array.from(parent.childNodes)
        .filter(function (node) { return node.nodeType === 1; })
        .filter(function (node) { return !node.classList.contains("glide__slide--clone"); });
    var legacyListName = (_a = parent.closest("[data-name]")) === null || _a === void 0 ? void 0 : _a.dataset.name;
    var isCarousel = parent.closest(".carousel");
    var _b = getListInfo(parent), listId = _b[0], listName = _b[1], listCategory = _b[2], searchTerm = _b[3];
    var customDimensions = __assign(__assign({}, (listCategory && { category_name: listCategory })), (searchTerm && { search_term: searchTerm }));
    // Send Impressions as view_item_list to GoogleAnalytics
    // Attach click handlers to select_item too
    var gaItems = tiles
        .map(function (tile) {
        if (shouldSendImpression(tile) === false)
            return;
        var index = siblings.indexOf(tile);
        var item = getGtagItemFromProductTile(tile, index);
        if (listId && listName && item) {
            tile.addEventListener("click", function () {
                return sendSelectItemEvent(listId, listName, [item], customDimensions);
            });
        }
        return item;
    })
        .filter(Boolean);
    if (gaItems.length > 0) {
        if (listId && listName) {
            sendViewItemListEvent(listId, listName, gaItems, customDimensions);
        }
    }
    // Don't touch this because BytePlus & PureInsights use some of the fields
    var items = tiles
        .map(function (tile) {
        var _a;
        if (shouldSendImpression(tile) === false)
            return;
        var index = siblings.indexOf(tile);
        var _b = tile.dataset, productId = _b.productId, category = _b.category, name = _b.name, price = _b.price, source = _b.source, retailerName = _b.retailerName, retailerId = _b.retailerId;
        var brand = (_a = tile.querySelector("[data-item-brand]")) === null || _a === void 0 ? void 0 : _a.textContent;
        if (!productId)
            return;
        var item = {
            id: parseInt(productId),
            category: category,
            brand: brand !== null && brand !== void 0 ? brand : undefined,
            name: name,
            price: price,
            list_name: legacyListName,
            list_position: index + 1,
            source: source,
            isCarousel: !!isCarousel,
        };
        var dimensions = {
            retailerName: retailerName || "",
            retailerId: retailerId || "",
        };
        tile.addEventListener("click", function () {
            new FruugoAnalyticsClickEvent(item).send();
        }, false);
        // Be careful when removing this, as it's required in the GA loop above
        tile.classList.add("impression-sent");
        return __assign(__assign({}, item), dimensions);
    })
        .filter(Boolean);
    if (items.length > 0) {
        var event_1 = new FruugoAnalyticsImpressionEvent(items);
        event_1.send();
    }
}
function getListInfo(parent) {
    var container = parent.closest(".products-list"); // Product Page List
    if (!container)
        container = parent.closest(".carousel"); // Carousel
    var _a = container === null || container === void 0 ? void 0 : container.dataset, listId = _a.listId, listName = _a.listName, listCategory = _a.listCategory, searchTerm = _a.searchTerm;
    return [listId, listName, listCategory, searchTerm];
}
function shouldSendImpression(tile) {
    // already sent in some previous call
    return !tile.classList.contains("impression-sent");
}
export function createProductImpressionObserver() {
    return new IntersectionObserver(function (entries) {
        var items = [];
        entries.forEach(function (entry) {
            if (!entry.isIntersecting)
                return;
            items.push(entry.target);
        });
        sendImpressionsForProductTiles(items);
    }, { threshold: [0.5] });
}
